export var LOCALES = [
    // { label: "languages.ar", value: "ar" },
    { label: "languages.de", value: "de" },
    { label: "languages.en", value: "en" },
    { label: "languages.fr", value: "fr" },
    { label: "languages.ru", value: "ru" },
    // { label: "languages.tr", value: "tr" },
];
